var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SharedTiming } from '@lean-body/src/interfaces';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button } from '../atoms';
import { HeartIcon } from '../atoms/icons/heart_icon';
import { ShareIcon } from '../atoms/icons/share_icon';
import { Colors } from '../styles';
import { isAndroidApp } from '@lean-body/src/util';
export const LessonMetaUserAction = ({ classObject, lesson, program, playlist, isFavorite, onClickFav, twitterService, onClickTwitterShareIfAuthed, onClickProgramPlayButton, }) => {
    const onClickShareButton = () => __awaiter(void 0, void 0, void 0, function* () {
        yield twitterService.onClickShare(SharedTiming.share_button, lesson, program, playlist);
        if (twitterService.isAuthorized)
            onClickTwitterShareIfAuthed();
    });
    return (React.createElement("div", { className: css(styles.container, classObject) },
        onClickFav && (React.createElement("div", { className: css(styles.left) },
            React.createElement(HeartIcon, { classObject: styles.actionFavoriteIcon, color: isFavorite ? Colors.PrimaryDark : Colors.Black, filled: isFavorite, onClick: onClickFav }),
            !isAndroidApp() && (React.createElement(ShareIcon, { classObject: styles.shareIcon, color: Colors.Black, onClick: onClickShareButton })))),
        onClickProgramPlayButton && program.videoSrc && (React.createElement(Button, { className: css(styles.button), onClick: onClickProgramPlayButton, isRadius: true },
            React.createElement("div", { className: css(styles.buttonInner) },
                React.createElement("img", { className: css(styles.intorduceIcon), src: "/assets/images/icons/program_introduce.svg" }),
                React.createElement("p", null, "\u7D39\u4ECB\u52D5\u753B\u3092\u898B\u308B"))))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    left: {
        display: 'flex',
        alignItems: 'center',
        gap: 17,
    },
    actionFavoriteIcon: {
        width: 26,
        height: 22,
        margin: '5px 3px',
        cursor: 'pointer',
    },
    shareIcon: {
        width: 21,
        height: 21,
        margin: 5,
        cursor: 'pointer',
    },
    button: {
        fontSize: 12,
        padding: '5px 30px',
    },
    buttonInner: {
        display: 'flex',
        alignItems: 'center',
    },
    intorduceIcon: {
        display: 'block',
        marginRight: 6,
    },
});
